import { store } from './index'

const fn = {
    // 获取页面所有组件id 列表
    getAllWidgetIdList() {
        const allWidget = store.getters.allLayers
        return Object.values(allWidget).map((item) => {
            // eslint-disable-next-line camelcase
            const {
                // eslint-disable-next-line camelcase
                id, id_name, key, label, type
            } = item
            return {
                id, id_name, key, label, type
            }
        })
    },

    // 根据id 获取组件
    getWidgetById(id) {
        const allWidget = store.getters.allLayers
        return allWidget[id]
    },

    setWidgetProps(id, props = {}) {
        store.dispatch('setWidgetProps', { id, props })
    },

    // 设置组件显示隐藏
    setWidgetVisibility(id, isShow) {
        store.dispatch('setWidgetVisibility', { id, show: isShow })
    }

}

export default fn
